import { useState } from "react";
import Select from "react-select";
import HospitalSelect from "../../../selectFilters/HospitalSelect";
import UserSelect from "../../../selectFilters/UserSelect";
import CheckedIcon from "../../../assets/checkedIcon.svg";
// Each filter gets passed value, setter, and options
export default function CaseFilters({
  AllCases,
  roleList,
  nextStepUser,
  setNextStepUser,
  statusList,
  caseStatus,
  setCaseStatus,
  subStatusList,
  commandCenterStage,
  setCommandCenterStage,
  hospitalList,
  hospitalId,
  setHospitalId,
  teamUserList,
  teamUserId,
  setTeamUserId,
  assignedTo,
  caseType,
  setCaseType,
  isTpa,
  setIsTpa,
  handleRemoveFilters,
  isFromClaimCases,
  searchPmjayId,
  handleSearchPmjayId,
  SearchIcon,
  handleGetAllCasesClick,
  setSelectedStage,
  assignedUserStages,
  admissionDialysisCount,
  admissionDialysisInitiationCount,
  claimDialysisCount,
  claimDialysisInitiationCount,

  admissionDialysisSelected,
  setAdmissionDialysisSelected,
  admissionDialysisInitiationSelected,
  setAdmissionDialysisInitiationSelected,
  claimDialysisSelected,
  setClaimDialysisSelected,
  claimDialysisInitiationSelected,
  setClaimDialysisInitiationSelected,
}) {
  const [searchPmjayIdValue, setSearchPmjayIdValue] = useState(searchPmjayId);

  // const dialysisCaseStages = [
  //   "Admission Documents Uploaded",
  //   "Admission Documents Re-uploaded",
  //   "Admission Documents Approved by Team B",
  //   "Admission Query Documents Uploaded",
  //   "Admission Query Documents Re-Uploaded",
  //   "Claim Documents uploaded",
  //   "Claim Documents Approved by Team D",
  //   "Claim Documents Re-Uploaded",
  //   "Claim Documents re- uploaded",
  //   "Claim Query Documents Uploaded",
  //   "Claim Query Documents Re-uploaded",
  //   "Admission Query Documents Approved by Doctor",
  //   "Claim Query Documents Approved by Doctor",
  // ];

  // const dialysisInitiationStages = [
  //   "Admission Documents Approved by Team C",
  //   "Admission Query Documents Approved by Sr Doctor",
  //   "Claim Documents Approved by Team E",
  //   "Claim Query Documents Approved by Sr Doctor",
  // ];

  const admissionDialysisStages = [
    "Admission Documents Uploaded",
    "Admission Documents Re-uploaded",
    "Admission Documents Approved by Team B",
    "Admission Query Documents Uploaded",
    "Admission Query Documents Re-Uploaded",
    "Admission Query Documents Approved by Doctor",
  ];

  const admissionDialysisInitiationStages = [
    "Admission Documents Approved by Team C",
    "Admission Query Documents Approved by Sr Doctor",
  ];

  const claimDialysisStages = [
    "Claim Documents uploaded",
    "Claim Documents Approved by Team D",
    "Claim Documents Re-Uploaded",
    "Claim Query Documents Uploaded",
    "Claim Query Documents Re-uploaded",
    "Claim Documents re- uploaded",
    "Claim Query Documents Approved by Doctor",
  ];

  const claimDialysisInitiationStages = [
    "Claim Documents Approved by Team E",
    "Claim Query Documents Approved by Sr Doctor",
  ];
  return (
    <div
      style={{ border: "1px solid #D4D4D4" }}
      className=" px-6 pb-3 my-5 rounded-[12px]"
    >
      <div>
        <div className="font-semibold my-2">Filter by</div>
        <div className="text-xs 2xl:text-sm grid grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-1 xl:gap-4 2xl:gap-6 items-center">
          {!isFromClaimCases && (
            <Select
              name="teamMember"
              isClearable
              options={roleList}
              getOptionLabel={(option) => option.roleName}
              getOptionValue={(option) => option.roleText}
              onChange={(item) => {
                setNextStepUser(item ? item.roleText : "");
              }}
              value={roleList.filter(
                (option) => option.roleText === nextStepUser,
              )}
              placeholder="TEAM - MEMBER"
            />
          )}
          {!isFromClaimCases && (
            <Select
              name="caseStatus"
              isClearable
              options={statusList}
              onChange={(item) => {
                setCaseStatus(item ? item.value : "");
              }}
              value={statusList.filter((option) => option.value === caseStatus)}
              placeholder="FILTER STATUS WISE"
            />
          )}
          {isFromClaimCases ? (
            <Select
              name="subStatus"
              isClearable
              options={[
                {
                  value: "Claim Sent To Bank on TMS",
                  label: "Claim Sent To Bank on TMS",
                },

                {
                  value: "Claim Amount Paid by Bank on TMS",
                  label: "Claim Amount Paid by Bank on TMS",
                },
                {
                  value: "Claim Received",

                  label: "Claim Received",
                },
              ]}
              onChange={(item) => setCommandCenterStage(item ? item.value : "")}
              placeholder="FILTER SUB STATUS WISE"
            />
          ) : (
            <Select
              name="subStatus"
              isClearable
              options={subStatusList}
              getOptionLabel={(option) => option.commandCenterStageStatus}
              getOptionValue={(option) => option.commandCenterStageStatus}
              onChange={(item) =>
                setCommandCenterStage(item ? item.commandCenterStageStatus : "")
              }
              value={subStatusList.filter(
                (item) => item.commandCenterStageStatus === commandCenterStage,
              )}
              placeholder="FILTER SUB STATUS WISE"
            />
          )}

          <HospitalSelect
            onChange={setHospitalId}
            hospitalIds={hospitalId}
            isMulti={true}
          />
          {!assignedTo && !isFromClaimCases && (
            <UserSelect
              onChange={setTeamUserId}
              teamUserId={teamUserId}
              assignedTo={assignedTo}
            />
          )}
          {!isFromClaimCases && (
            <Select
              name="caseType"
              isClearable
              options={[
                { value: "SURGICAL", label: "SURGICAL" },
                { value: "CONSERVATIVE", label: "CONSERVATIVE" },
                { value: "DAYCARE", label: "DAYCARE" },
              ]}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              onChange={(item) => setCaseType(item ? item.value : "")}
              value={[
                { value: "SURGICAL", label: "SURGICAL" },
                { value: "CONSERVATIVE", label: "CONSERVATIVE" },
                { value: "DAYCARE", label: "DAYCARE" },
              ].filter((option) => option.value === caseType)}
              placeholder="FILTER CASE TYPE WISE"
            />
          )}

          {/* <div className="col-span-1 w-fit">
            <div
              className="w-fit flex items-center gap-2 border border-solid border-[#DEDEDE] rounded-[8px] p-2"
              onClick={() => {
                setDialysisSelected(!dialysisSelected);
                
                setAdmissionDialysisSelected(false);
                setAdmissionDialysisInitiationSelected(false);
                setClaimDialysisSelected(false);
                setClaimDialysisInitiationSelected(false);

                dialysisSelected
                  ? setSelectedStage({ id: "-1", stages: assignedUserStages })
                  : setSelectedStage({ id: "-1", stages: dialysisCaseStages });
              }}
            >
              {dialysisSelected ? (
                <div>
                  <img src={CheckedIcon} alt="checked-icon" />{" "}
                </div>
              ) : (
                <div className="h-[28px] w-[28px] bg-white border border-solid border-[#DEDEDE] rounded-full " />
              )}
              <span className="font-semibold text-base text-[#666666] -tracking-[5%]">
                Dialysis Approval Pending (
                <span className="text-[#E83D3D]">
                  {dialysisCaseCount} Cases
                </span>
                )
              </span>
            </div>
          </div> */}
          {/* <div className="col-span-1 w-full">
            <div
              className="w-full max-w-full flex items-center gap-2 border border-solid border-[#DEDEDE] rounded-[8px] px-3 py-2 break-words"
              onClick={() => {
                setDialysisInitiationSelected(!dialysisInitiationSelected);
                
                setAdmissionDialysisSelected(false);
                setAdmissionDialysisInitiationSelected(false);
                setClaimDialysisSelected(false);
                setClaimDialysisInitiationSelected(false);

                dialysisInitiationSelected
                  ? setSelectedStage({ id: "-1", stages: assignedUserStages })
                  : setSelectedStage({
                      id: "-1",
                      stages: dialysisInitiationStages,
                    });
              }}
            >
              {dialysisInitiationSelected ? (
                <div>
                  <img src={CheckedIcon} alt="checked-icon" />
                </div>
              ) : (
                <div className="h-[28px] w-[28px] bg-white border border-solid border-[#DEDEDE] rounded-full" />
              )}

              <span className="font-semibold text-base text-[#666666] -tracking-[5%]">
                Dialysis Initiation Pending (
                <span className="text-[#E83D3D]">
                  {dialysisInitiationCount} Cases
                </span>
                )
              </span>
            </div>
          </div> */}
          {/* <div className="col-span-1 w-full">
            <div
              className="w-full flex items-center gap-2 border border-solid border-[#DEDEDE] rounded-[8px] px-3 py-2"
              onClick={() => {
                setAdmissionDialysisSelected(!admissionDialysisSelected);

                // reset all others

                setAdmissionDialysisInitiationSelected(false);
                setClaimDialysisSelected(false);
                setClaimDialysisInitiationSelected(false);

                admissionDialysisSelected
                  ? setSelectedStage({ id: "-1", stages: assignedUserStages })
                  : setSelectedStage({
                      id: "-1",
                      stages: admissionDialysisStages,
                    });
              }}
            >
              {admissionDialysisSelected ? (
                <img src={CheckedIcon} alt="checked-icon" />
              ) : (
                <div className="h-[28px] w-[28px] bg-white border border-solid border-[#DEDEDE] rounded-full flex-shrink-0" />
              )}

              <span className="font-semibold text-base text-[#666666]">
                Admission Dialysis Pending (
                <span className="text-[#E83D3D]">
                  {admissionDialysisCount} Cases
                </span>
                )
              </span>
            </div>
          </div>
          <div className="col-span-1 w-full">
            <div
              className="w-full flex items-center gap-2 border border-solid border-[#DEDEDE] rounded-[8px] px-3 py-2"
              onClick={() => {
                setAdmissionDialysisInitiationSelected(
                  !admissionDialysisInitiationSelected,
                );

                setAdmissionDialysisSelected(false);
                setClaimDialysisSelected(false);
                setClaimDialysisInitiationSelected(false);

                admissionDialysisInitiationSelected
                  ? setSelectedStage({ id: "-1", stages: assignedUserStages })
                  : setSelectedStage({
                      id: "-1",
                      stages: admissionDialysisInitiationStages,
                    });
              }}
            >
              {admissionDialysisInitiationSelected ? (
                <img src={CheckedIcon} />
              ) : (
                <div className="h-[28px] w-[28px] bg-white border border-solid border-[#DEDEDE] rounded-full shrink-0" />
              )}

              <span className="font-semibold text-base text-[#666666]">
                Admission Initiation Dialysis Pending (
                <span className="text-[#E83D3D]">
                  {admissionDialysisInitiationCount} Cases
                </span>
                )
              </span>
            </div>
          </div>
          <div className="col-span-1 w-full">
            <div
              className="w-full flex items-center gap-2 border border-solid border-[#DEDEDE] rounded-[8px] px-3 py-2"
              onClick={() => {
                setClaimDialysisSelected(!claimDialysisSelected);

                setAdmissionDialysisSelected(false);
                setAdmissionDialysisInitiationSelected(false);
                setClaimDialysisInitiationSelected(false);

                claimDialysisSelected
                  ? setSelectedStage({ id: "-1", stages: assignedUserStages })
                  : setSelectedStage({
                      id: "-1",
                      stages: claimDialysisStages,
                    });
              }}
            >
              {claimDialysisSelected ? (
                <img src={CheckedIcon} alt="checked-icon" />
              ) : (
                <div className="h-[28px] w-[28px] bg-white border border-solid border-[#DEDEDE] rounded-full flex-shrink-0" />
              )}

              <span className="font-semibold text-base text-[#666666]">
                Claim Dialysis Pending (
                <span className="text-[#E83D3D]">
                  {claimDialysisCount} Cases
                </span>
                )
              </span>
            </div>
          </div>
          <div className="col-span-1 w-full">
            <div
              className="w-full flex items-center gap-2 border border-solid border-[#DEDEDE] rounded-[8px] px-3 py-2"
              onClick={() => {
                setClaimDialysisInitiationSelected(
                  !claimDialysisInitiationSelected,
                );

                setAdmissionDialysisSelected(false);
                setAdmissionDialysisInitiationSelected(false);
                setClaimDialysisSelected(false);

                claimDialysisInitiationSelected
                  ? setSelectedStage({ id: "-1", stages: assignedUserStages })
                  : setSelectedStage({
                      id: "-1",
                      stages: claimDialysisInitiationStages,
                    });
              }}
            >
              {claimDialysisInitiationSelected ? (
                <img src={CheckedIcon} alt="checked-icon" />
              ) : (
                <div className="h-[28px] w-[28px] bg-white border border-solid border-[#DEDEDE] rounded-full flex-shrink-0" />
              )}

              <span className="font-semibold text-base text-[#666666]">
                Claim Dialysis Initiation Pending (
                <span className="text-[#E83D3D]">
                  {claimDialysisInitiationCount} Cases
                </span>
                )
              </span>
            </div>
          </div> */}
          <div
            style={{ border: "1px solid #DEDEDE" }}
            className="flex items-center gap-2 px-4 py-[6px] ml-4 2xl:ml-0 rounded-[8px] bg-white"
          >
            <img src={SearchIcon} alt="search-icon" />
            <input
              type="text"
              value={searchPmjayIdValue}
              className="outline-none border-0"
              onChange={(e) => {
                setSearchPmjayIdValue(e.target.value);
                handleSearchPmjayId(e);
              }}
              placeholder="Search by Registration Id"
            />
          </div>
          <Select
            name="scheme"
            isClearable
            options={[
              { value: 0, label: "PMJAY" },
              { value: 1, label: "TPA" },
            ]}
            onChange={(item) =>
              setIsTpa?.(item ? item.value : "")
            }
            value={[
              { value: 0, label: "PMJAY" },
              { value: 1, label: "TPA" },
            ].filter((option) => option.value === isTpa)}
            placeholder="FILTER SCHEME WISE"
          />
          <div
            style={{ border: "1px solid #017C57" }}
            className="w-fit font-semibold text-[#017C57] px-5 py-2 rounded-full cursor-pointer"
            onClick={handleRemoveFilters}
          >
            Remove All Filters
          </div>
        </div>
      </div>
    </div>
  );
}
